/** QuickRouter — Barre d'outils de l'éditeur : outils, couche active, affichages, routage
 *  automatique, DRC, cadrage. */
import { useProjectStore } from '../store/useProjectStore.js';
import { runDrc } from '../../shared/drc.js';
import * as ops from '../../shared/ops.js';
import { copperLayers, routableLayers, layerRole, LAYER_COLORS, LAYER_LABELS } from '../../shared/layers.js';

export default function Toolbar() {
  const tool = useProjectStore((s) => s.tool);
  const setTool = useProjectStore((s) => s.setTool);
  const layer = useProjectStore((s) => s.layer);
  const setLayer = useProjectStore((s) => s.setLayer);
  const show = useProjectStore((s) => s.show);
  const toggle = useProjectStore((s) => s.toggleShow);
  const routing = useProjectStore((s) => s.routing);
  const autoroute = useProjectStore((s) => s.autoroute);
  const mutate = useProjectStore((s) => s.mutate);
  const fit = useProjectStore((s) => s.fit);
  const drc = useProjectStore((s) => s.drc);
  const setDrc = useProjectStore((s) => s.setDrc);
  const setStatus = useProjectStore((s) => s.setStatus);
  const ro = useProjectStore((s) => s.project.role === 'viewer');
  const busy = useProjectStore((s) => !!s.ai.job);
  const board = useProjectStore((s) => s.project.board);
  const cu = copperLayers(board);
  const sig = routableLayers(board);
  // Couche non encore réglée = visible : le premier clic la masque.
  const flipLayer = (L) => useProjectStore.setState({ show: { ...show, [L]: show[L] === false } });

  const check = () => {
    const st = useProjectStore.getState();
    const r = runDrc(st.project, st.lookup());
    setDrc(r);
    setStatus(r.ok ? '✓ DRC : aucune erreur' : `DRC : ${r.summary.errors} erreur(s), ${r.summary.warnings} avertissement(s) — cercles magenta sur la carte, détail dans Fabrication`);
  };

  return (
    <div className="toolbar">
      <div className="seg">
        <button className={tool === 'select' ? 'active' : ''} onClick={() => setTool('select')} title="Sélection / déplacement (Échap)">↖ Sélection</button>
        <button className={tool === 'track' ? 'active' : ''} disabled={ro} onClick={() => setTool('track')} title="Tracer une piste (X)">╱ Piste</button>
        <button className={tool === 'via' ? 'active' : ''} disabled={ro} onClick={() => setTool('via')} title="Poser un via">◉ Via</button>
      </div>
      {sig.length <= 2 ? (
        <div className="seg" title="Couche active des pistes (V pendant le tracé)">
          <button className={layer === 'F' ? 'active layer-f' : ''} onClick={() => setLayer('F')}>Dessus</button>
          <button className={layer === 'B' ? 'active layer-b' : ''} onClick={() => setLayer('B')}>Dessous</button>
        </div>
      ) : (
        <select value={sig.includes(layer) ? layer : 'F'} onChange={(e) => setLayer(e.target.value)} title="Couche active des pistes (V pendant le tracé : couche de signal suivante)" style={{ borderColor: LAYER_COLORS[layer] }}>
          {sig.map((L) => <option key={L} value={L}>{LAYER_LABELS[L]}</option>)}
        </select>
      )}
      <div className="seg" title="Couches affichées">
        {cu.map((L) => (
          <button key={L} className={show[L] !== false ? 'active' : ''} onClick={() => flipLayer(L)} title={`Afficher ${LAYER_LABELS[L]}${layerRole(board, L) === 'plane' ? ' (plan)' : ''}`}
            style={show[L] !== false ? { borderBottom: `2px solid ${LAYER_COLORS[L]}` } : undefined}>{L}</button>
        ))}
      </div>
      <div className="seg">
        {[['rats', 'Chevelu'], ['zones', 'Plans'], ['pinNames', 'Noms'], ['drc', 'DRC']].map(([k, l]) => (
          <button key={k} className={show[k] ? 'active' : ''} onClick={() => toggle(k)} title={`Afficher : ${l}`}>{l}</button>
        ))}
      </div>
      <span className="grow" />
      <button className="primary" disabled={ro || routing || busy} onClick={() => autoroute(null)} title="Route tous les nets (les pistes manuelles sont gardées)">
        {routing ? <><span className="spinner" /> Routage…</> : '⚡ Router'}
      </button>
      <button disabled={ro || routing || busy} onClick={() => window.confirm('Effacer toutes les pistes et vias du routeur automatique ?') && mutate((p) => ops.clearRoutes(p, { autoOnly: true }))} title="Effacer le routage automatique">Effacer auto</button>
      <button onClick={check} title="Contrôle des règles de conception">{drc ? (drc.ok ? '✓ DRC' : `✗ DRC ${drc.summary.errors}`) : 'DRC'}</button>
      <button className="icon" onClick={fit} title="Cadrer la carte (F)">⤢</button>
    </div>
  );
}
